import { Component, EventEmitter, Input, Output, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AddPopupComponent } from '../add-popup/add-popup.component';
import { faXmark, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-setup-text-table',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AddPopupComponent, FontAwesomeModule],
  templateUrl: './setup-text-table.component.html',
  styleUrl: './setup-text-table.component.css'
})
export class SetupTextTableComponent implements OnInit, OnChanges {
  faXmark = faXmark;
  faTrashCan = faTrashCan;
  showModal = false;
  isEditMode = false;
  showDeleteModal = false;
  editIndex: number | null = null;
  selectedId: number | null = null;
  showSkeleton = true;
  @Input() setupText: any[] = [];
  @Input() types: any[] = [];
  @Input() orgId: any = null;
  @Input() loading = false;
  @Output() addAutomation = new EventEmitter<{ id: any, text: string, org_id: any }>();
  @Output() editAutomation = new EventEmitter<{ id: any, data: { id: any, text: string, org_id: any } }>();
  @Output() deleteAutomation = new EventEmitter<any>();

  automationForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.automationForm = this.fb.group({
      text: ['', Validators.required],
      typeId: [null, Validators.required]
    });
  }
  ngOnChanges() {
    if (this.loading) {
      this.showTableLoader();
    }
  }
  ngOnInit(): void {
    this.showTableLoader();
  }
skeletonRows: any[] = [];
skeletonCols: any[] = [];

showTableLoader(duration = 800) {
  this.showSkeleton = true;

  const rowCount = this.setupText?.length || 5;
  const columnCount = 3; 

  this.skeletonRows = Array(rowCount).fill(0);
  this.skeletonCols = Array(columnCount).fill(0);

  setTimeout(() => {
    this.showSkeleton = false;
  }, duration);
}

  toggleModal() {
    this.showModal = !this.showModal;
    if (!this.showModal) {
      this.isEditMode = false;
      this.editIndex = null;
      this.selectedId = null;
      this.automationForm.reset();
    }
  }

  openEditModal(item: any, index: number) {
    this.isEditMode = true;
    this.editIndex = index;
    this.showModal = true;
    this.selectedId = item?.id ?? null;
    this.automationForm.patchValue({
      text: item.text,
      typeId: item.type_id ?? null
    });
  }

  onSave() {
    if (this.automationForm.invalid) return;

    const formValue = this.automationForm.value;
    const payload = {
      id: formValue.typeId,
      text: formValue.text,
      org_id: this.orgId
    };

    if (this.isEditMode && this.editIndex !== null && this.selectedId !== null) {
      this.editAutomation.emit({ id: this.selectedId, data: payload });
    } else {
      this.addAutomation.emit(payload);
    }
    this.toggleModal();
  }

  openDeleteModal(id: number) {
    this.selectedId = id;
    this.showDeleteModal = true;
  }

  confirmDelete() {
    if (this.selectedId != null) {
      this.deleteAutomation.emit(this.selectedId);
    }
    this.closeDeleteModal();
  }

  closeDeleteModal() {
    this.showDeleteModal = false;
    this.selectedId = null;
  }
}
